import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Music } from 'lucide-react';

export default function PendingActivationPage() {
  return (
    <div className="min-h-screen bg-[#1A1A2E] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#E94560] mb-4"><Music size={28} className="text-white" /></div>
        <Clock size={48} className="mx-auto text-yellow-500 mb-4" />
        <h2 className="text-xl font-bold text-pn-dark mb-2">Account in attesa di attivazione</h2>
        <p className="text-gray-500 text-sm mb-6">La tua email è stata verificata. Il tuo account verrà attivato a breve dall'amministratore. Riceverai una email di conferma.</p>
        <Link to="/login" className="btn-secondary inline-block">Torna al Login</Link>
      </div>
    </div>
  );
}
